import React from 'react';

import {
  Box,
  Flex,
  Grid,
  GridItem,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
} from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { TextLabel } from 'uiToolkitV1/Typography';

import { COLOR_MAP_OKR_PIE_CHART, StatusPieChart } from './StatusPieChart';

interface Props {
  progress: Record<string, any>;
}

const StatusCell = ({ progress }: Props) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const chartData = COLOR_MAP_OKR_PIE_CHART.map(({ barColor, key, label }) => ({
    key,
    name: key,
    value: progress?.progressCount?.[key]?.count ?? 0,
    avgPercentage: progress?.progressCount?.[key]?.avgPercentage ?? 0,
    count: progress?.progressCount?.[key]?.count ?? 0,
    color: barColor,
    label,
  }));
  return (
    <Popover trigger="hover" matchWidth isLazy>
      {({ isOpen }) => (
        <Flex alignItems="center" justifyContent="center" h="100%" w="100%" cursor="pointer">
          {/* @ts-ignore */}
          <PopoverTrigger>
            <Box
              h="80%"
              w="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                background: isOpen ? '#E6F1FD' : 'transparent',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              <Box h="48px" w="48px" cursor="pointer">
                <StatusPieChart data={chartData} innerRadius={12} outerRadius={22} />
              </Box>
            </Box>
          </PopoverTrigger>
          <Portal>
            <PopoverContent
              maxWidth="280px"
              boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.08)"
              border="none"
              p="12px"
              cursor="pointer"
            >
              <PopoverBody
                sx={{
                  borderRadius: '8px',
                }}
                p="0"
              >
                <Flex flexDir="column">
                  <TextLabel bold color="text.g2" mb="4px">
                    Child {moduleName} Status
                  </TextLabel>
                  <Flex alignItems="center">
                    <Flex alignItems="center" justifyContent="center" h="80px" w="80px">
                      <StatusPieChart data={chartData} />
                    </Flex>
                    <Flex direction="column" ml="4px">
                      <Grid templateColumns="repeat(4, 1fr)">
                        {chartData.map(({ label, count, name }) => (
                          <>
                            <GridItem colSpan={3}>
                              <TextLabel
                                key={label}
                                color={COLOR_MAP_OKR_PIE_CHART.find(({ key }) => key === name)?.barColor}
                              >{`${label} : `}</TextLabel>
                            </GridItem>
                            <GridItem colSpan={1}>
                              <TextLabel
                                key={count}
                                color={COLOR_MAP_OKR_PIE_CHART.find(({ key }) => key === name)?.barColor}
                                textAlign="right"
                              >
                                {count}
                              </TextLabel>
                            </GridItem>
                          </>
                        ))}
                      </Grid>
                    </Flex>
                  </Flex>
                </Flex>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </Flex>
      )}
    </Popover>
  );
};

export { StatusCell };
